import { AUTH_LOGIN_USER, AUTH_LOGOUT_USER, AUTH_USER_INFO } from '../types'
import { wakeupServer, wakeupTimestamp } from '../app/actions'
import { getAuth, onAuthStateChanged, signInWithEmailLink, signInWithEmailAndPassword, signOut, EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth'
import { getFirestore, doc, onSnapshot } from 'firebase/firestore'
import { getFunctions, httpsCallable } from 'firebase/functions'

// :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// [START]: ALL LISTENERS HERE :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	// [START]: Auth Listener ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
		let monitorLogin
		let monitorUser
		export function monitorLoginStatus(){
			return (dispatch, getstate, firebase) => {
				const auth = getAuth(firebase)
			   console.log('monitorLoginStatus')
				monitorLogin = onAuthStateChanged(auth, user => {
					if (user) {
						dispatch({ type: AUTH_LOGIN_USER })
						dispatch(monitorUserInfo(user.uid))
					} else {
						dispatch(logOut()) //{ type: AUTH_LOGOUT_USER }
					}
				})
			}
		}
		export function stopMonitoringLoginStatus(){
			return (dispatch) => {
			console.log('stopMonitoringLoginStatus')
				monitorLogin && monitorLogin()
				monitorUser && monitorUser()
			}
		}
	// [END]: Auth Listener :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

	// [START]: User Profile Listener :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
		export function monitorUserInfo(uid) {
			return (dispatch, getstate, firebase) => {  
				const db = getFirestore(firebase)
				const docRef = doc(db, 'users', uid)
            monitorUser = onSnapshot(docRef, querySnapshot => { 
					if (querySnapshot.data()) {
						let data = querySnapshot.data()
						dispatch({ type: AUTH_USER_INFO, payload: data })
					}
				}, err => {
					console.log('monitorUserInfo error:', err)
				})
			}
		}
	// [END]: User Profile Listener :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// [END]: ALL LISTENERS HERE :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// [START]: ALL WAKEUP FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++		
   export function wakeupLoginPopup() {
      return (dispatch) => { 
         dispatch(wakeupServer('ttShortCodeLogin'))
         dispatch(wakeupServer('ttShortCodeConfirm'))
         dispatch(wakeupServer('ttUpdateRequestEmail'))
         dispatch(wakeupServer('ttUpdateUserProfile'))         
         return null
      }
   }
// [END]: ALL WAKEUP FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++


// [START]: Login & Logout Process :::::::::::::::::::::::::::::::::::::::::::::::::::::::
// :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	export function logIn(email, password) {
		return (dispatch, getstate, firebase) => new Promise(function (resolve, reject) {
         const auth = getAuth(firebase)
         signInWithEmailAndPassword(auth, email.toLowerCase(), password)
			.then(() => {
				dispatch({ type: AUTH_LOGIN_USER })  
				resolve()
			})
			.catch((e) => {
	   		reject(e.message)
	      })
		})
	}
   export function logOut(){
		return (dispatch, getstate, firebase) => {
			const auth = getAuth(firebase)
			signOut(auth)
			.then(() => {
				dispatch({ type: AUTH_LOGOUT_USER })   
				// reducers are reset in reducers.js
				// '''''''''''''''''''''''''''''''''   
			}).catch((err) => {
				dispatch({ type: AUTH_LOGOUT_USER })
			})
		}
	}

   export function shortCodeLogin(email){
      return (dispatch, getstate, firebase) => new Promise(function (resolve, reject) {
	      const functions = getFunctions(firebase)
         // Setup return link
			let link = 'https://'+window.location.hostname
			if (window.location.hostname === 'localhost') {
				link = 'http://localhost:3000'
			}
			// Setup actionCodeSettings
			let actionCodeSettings = {
				url: link,
				handleCodeInApp: true
			}

         const submitEmailConfirmation = httpsCallable(functions, 'ttShortCodeLogin')
	      submitEmailConfirmation({email:email.toLowerCase(), actionCodeSettings:actionCodeSettings})
	      .then(() => {
	      	dispatch(wakeupTimestamp('ttShortCodeLogin')) // record last time function was used
            resolve()
	      })
	      .catch((e) => {
	      	let error = {title:'Error',message:''}
	      	try { error = JSON.parse(e.message) } 
	      	catch (err) { error.message = (e.message === 'internal') ? 'Error connecting to server.' : e.message }
	      	reject(error.message)
	      })
      }) 
	}

   export function shortCodeConfirmation(email, code){
      return (dispatch, getstate, firebase) => new Promise(function (resolve, reject) {
	      const functions = getFunctions(firebase)
	      const auth = getAuth(firebase)
         const submitEmailConfirmationConfirm = httpsCallable(functions, 'ttShortCodeConfirm')
	      submitEmailConfirmationConfirm({email:email.toLowerCase(), code:code})
	      .then((returned) => {
	      	// -----
	      	dispatch(wakeupTimestamp('ttShortCodeConfirm')) // record last time function was used
	      	let link = returned.data
            signInWithEmailLink(auth, email.toLowerCase(), link)
				.then(function(result) {
					dispatch({ type: AUTH_LOGIN_USER })
					resolve()
				})
				.catch(function(e) {
					reject(e.message)
				})
				// -----
	      })
         .catch((e) => {
	      	let error = {title:'Error',message:''}
	      	try { error = JSON.parse(e.message) } 
	      	catch (err) { error.message = (e.message === 'internal') ? 'Error connecting to server.' : e.message }
	      	reject(error.message)
	      })
      })
	}
	
	export function emailLogInConfirm(email, url, requestId){
		return (dispatch, getstate, firebase) => new Promise(function (resolve, reject) {	
			const auth = getAuth(firebase)
         const functions = getFunctions(firebase)
         
         if (email && url) {
            signInWithEmailLink(auth, email.toLowerCase(), url)
				.then(function(result) {
					// login user .....
					window.localStorage.removeItem('emailForSignIn')
					dispatch({ type: AUTH_LOGIN_USER })
               // Update request email .....
               const submitUpdateEmail = httpsCallable(functions, 'ttUpdateRequestEmail')
	            submitUpdateEmail({email:email.toLowerCase(), requestId:requestId})
	            dispatch(wakeupTimestamp('ttUpdateRequestEmail')) // record last time function was used
					resolve()
				})
				.catch(function(e) {
					reject(e.message)
				})
         } else {
				reject('Please enter your email address')
			}
		})
	}
// :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::	
// [END]: Login & Logout Process :::::::::::::::::::::::::::::::::::::::::::::::::::::::::

// [START]: Update Profile Functions :::::::::::::::::::::::::::::::::::::::::::::::::::::
// :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
	export function updateUserInfo(userInfo) {
		return (dispatch, getstate, firebase) => new Promise(function (resolve, reject) {    
		   const functions = getFunctions(firebase)
         const updateProfile = httpsCallable(functions, 'ttUpdateUserProfile')
			updateProfile({ userInfo })
			.then(() => {
            dispatch(wakeupTimestamp('ttUpdateUserProfile')) // record last time function was used
			   resolve('success')
			})
			.catch((e) => {
	      	let error = {title:'Error',message:''}
	      	try { error = JSON.parse(e.message) } 
	      	catch (err) { error.message = (e.message === 'internal') ? 'Error connecting to server.' : e.message }
	      	reject(error)
	      })
		})
	}
	export function updateUserPassword(oldPassword, newPassword) {
		return (dispatch, getstate, firebase) => new Promise(async function (resolve, reject) {
			const auth = getAuth(firebase)
			// Reauthenticate user with current password.
			if (oldPassword !== '') {
				try {
					const userEmail = getstate().auth.userInfo.email
               const credentials = EmailAuthProvider.credential(userEmail, oldPassword)			
               await reauthenticateWithCredential(auth.currentUser, credentials)
				}
				catch (error) {
					if (error.message === 'The password is invalid or the user does not have a password.') {
						return reject('The Current Password you entered is invalid, please try again or login through your email.')
					} else {
						return reject('Error authenticating your account, please re-enter your current password or login through your email then set your password.')    
					}
				}
			} 
         // Set new password
			if(newPassword){
				updatePassword(auth.currentUser, newPassword)
				.then(function() {
					resolve('Password updated')
				})
				.catch(function(error) {
					if (error.code === 'auth/requires-recent-login') {
						reject('Please enter your Current Password.')    
					} else {
						reject('Sorry, there was an error: ', error.message)  
					}
				})
			} else {
				reject('Please enter your password.')
			}  
		})
	}
// ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// [END]: Update Profile Functions ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
